import React, {useState} from 'react';
import {CheckoutProvider, PaymentElement, useCheckout} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import {notifyError} from '@nutastic/nutastic-react-app';
import makeFetchCall from "../../../../utils/makeFetchCall";
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const componentClass = 'stripePaymentProcessor'
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
//TODO: turn this into a configuration
const stripePromise = loadStripe(window.hasOwnProperty('nutasticAppConfig') ? window.nutasticAppConfig.stripePublicKey : 'needNuKey');

const CheckoutForm = ({ title, description }) => {
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState(false);
    const checkout = useCheckout();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setHasBeenSubmitted(true);
        console.log('Checkout Items', checkout.lineItems);
        const result = await checkout.confirm();

        if (result.type === 'error') {
            notifyError('paymentNotification', 'Uh Oh, Payment Failed...', 'We were unable to process your payment, please try again.')
            console.error(result.error.message);
        } else {
            console.log('Redirecting now that payment was successful');
        }
    };

    return (
        <form onSubmit={handleSubmit} className="mt-5 mb-5">
            <pre className="d-none">
                {JSON.stringify(checkout.lineItems, null, 2)}
            </pre>
            { title && <h3>{ title }</h3> }
            { description && <p>{ description }</p> }
            <h2><b>Total:</b> {checkout.total.total.amount}</h2>
            <PaymentElement />
            <button className="btn btn-block btn-dark-red mt-5" disabled={hasBeenSubmitted}>
                { hasBeenSubmitted ? "Processing..." : "Complete Purchase" }
            </button>
        </form>
    );
};

const StripePaymentProcessor = ({ isSigningUp, guestEmail, products, title, description, onCancel }) => {
    const [isLoading, setIsLoading] = useState(true);

    const fetchClientSecret = async () => {
        const fetchResult = await makeFetchCall('/api/payments-processor/stripe/create-order', { products, guestEmail, isSigningUp });
        setTimeout(() => setIsLoading(false), 250);
        return fetchResult?.checkoutSessionId;
    };

    return <div className={componentClass}>
        { isLoading && <Spin indicator={<LoadingOutlined className="loadingIcon" />} spin={true} className={`${componentClass}__spinner`} /> }
        <CheckoutProvider stripe={stripePromise} options={{ fetchClientSecret }}>
            <CheckoutForm description={description} title={title} />
        </CheckoutProvider>
        { onCancel && <div className="linkTextButton mt-5 animated fadeIn delay-3s" onClick={onCancel}>Go Back</div> }
    </div>;
};

export default StripePaymentProcessor;
